import { showToast } from 'components/common/CustomToast';
import { getBrand, getModel } from 'react-native-device-info';
import InAppReview from 'react-native-in-app-review';
import Logger from 'utils/Logger';

export const rateApp = async () => {
  const isAvailable = InAppReview.isAvailable();
  if (isAvailable) {
    try {
      await InAppReview.RequestInAppReview();
      return true;
    } catch (error) {
      Logger.error(`Rate app | Error: ${error}`);
      showToast('error.rateApp.generic', 'error');
      return false;
    }
  } else {
    Logger.warn(`Rate app | Device not supported: ${getBrand()} ${getModel()}`);
    showToast('error.rateApp.notAvailable', 'error');
    return false;
  }
};
